export default function () {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.3729 11.9989C22.3729 17.7303 17.7304 22.3718 11.9999 22.3718C6.27248 22.3718 1.62695 17.7303 1.62695 11.9989C1.62695 6.26941 6.27248 1.62793 11.9999 1.62793C17.7304 1.62793 22.3729 6.26941 22.3729 11.9989ZM18.0718 8.67222L16.4591 7.06056L9.73487 13.7959L7.53978 11.5937L5.92812 13.2023L9.66707 16.9392L9.7349 16.8693L9.80174 16.9392L18.0718 8.67222Z"
                fill="black"
            />
        </svg>
    );
}
